<template>
  <div class="animated fadeIn">
    <ValidationObserver v-slot="{ invalid }">
      <div>
        <b-row>
          <b-col sm="6">
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              name="Customer ID"
            >
              <c-input
                type="text"
                v-model="userinfo.customerNo"
                lableText="*Customer ID"
              />
              <span class="validate-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-col>
          <b-col sm="6">
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              name="Customer Name"
            >
              <c-input
                inputType="text"
                lableText="*Customer Name"
                v-model="userinfo.customerName"
                class="mt-0"
              />
              <span class="validate-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-col>
        </b-row>
        <b-row>
          <b-col md-6>
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              name="phone number"
            >
              <c-tel-input
                v-model="userinfo.phone"
                inputType="number"
                class="m-0"
              />
              <span class="validate-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-col>
          <b-col md-6>
            <ValidationProvider
              rules="required|email"
              v-slot="{ errors }"
              name="Email"
            >
              <c-input
                inputType="text"
                lableText="*Email"
                v-model="userinfo.email"
                class="mt-0"
              />
              <span class="validate-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-col>
        </b-row>
        <b-row>
          <b-col md-6>
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              name="Service ID"
            >
              <c-input
                type="text"
                v-model="userinfo.serviceId"
                lableText="*Service ID"
              />
              <span class="validate-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-col>
          <b-col md-6>
            <eb-select
              type="select"
              :selected="userinfo.serviceType"
              :options="['SD','HD']"
              v-model="userinfo.serviceType"
              label="text"
              :id="'selecttype'"
              placeholder="Service Type(optional)"
            ></eb-select>
          </b-col>
        </b-row>
        <b-row>
          <b-col md-6>
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              name="Country"
            >
              <c-input
                type="text"
                v-model="userinfo.address.country"
                lableText="*Country"
              />
              <span class="validate-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-col>
          <b-col md-6>
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              name="State"
            >
              <c-input
                type="text"
                v-model="userinfo.address.state"
                lableText="*State"
              />
              <span class="validate-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-col>
        </b-row>
        <b-row>
          <b-col md-6>
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              name="Street 1"
            >
              <c-input
                type="text"
                v-model="userinfo.address.address1"
                lableText="*Street 1"
              />
              <span class="validate-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-col>
          <b-col md-6>
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              name="Street 2"
            >
              <c-input
                type="text"
                v-model="userinfo.address.address2"
                lableText="*Street 2"
              />
              <span class="validate-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-col>
        </b-row>
        <b-row>
          <b-col md-6>
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              name="City"
            >
              <c-input
                type="text"
                v-model="userinfo.address.city"
                lableText="*City"
              />
              <span class="validate-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-col>
          <b-col md-6>
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              name="zipcode"
            >
              <c-input
                inputType="number"
                v-model="userinfo.address.pinCode"
                lableText="*Zipcode"
              />
              <span class="validate-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-col>
        </b-row>
          <b-row>
          <b-col sm="6">
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              name="MSO"
            >
              <c-input
                type="text"
                v-model="userinfo.MSO"
                lableText="*MSO"
              />
              <span class="validate-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-col>
          </b-row>
        <div class="text-center mb-5 mt-5">
          <b-button
            class="btn btn-lg btn-success ml-3 w-25"
            :disabled="invalid"
            @click.prevent="handleSubmit"
          >
            Save
          </b-button>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import cInput from "@/components/FormElements/CustomInput";
import cTelInput from "@/components/FormElements/MobileNumberInput";
import ebSelect from "@/components/FormElements/Select.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ebButton from "@/components/FormElements/Button";
export default {
  name: "CreateNewCustomers",
  components: {
    cInput,
    cTelInput,
    ebSelect,
    ebButton,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      userinfo: {
        customerNo: "",
        serviceId: "",
        email: "",
        phone: "",
        customerName: "",
        serviceType:"",
        MSO:"",
        address: {
          country: "",
          state: "",
          city: "",
          pinCode: "",
          address1: "",
          address2: "",
        },
      },
    };
  },
  methods: {
    async handleSubmit() {
      let data = {
        customerName: this.userinfo.customerName,
        email: this.userinfo.email,
        phone: this.userinfo.phone,
        serviceId: this.userinfo.serviceId,
        customerNo: this.userinfo.customerNo,
        MSO:this.userinfo.MSO,
        serviceType: this.userinfo.serviceType,
        address: {
          address1: this.userinfo.address.address1,
          address2: this.userinfo.address.address2,
          state: this.userinfo.address.state,
          city: this.userinfo.address.city,
          pinCode: this.userinfo.address.pinCode,
          country: this.userinfo.address.country,
        },
      };
      const response = await this.$store
        .dispatch("partner/createCustomer", data)
        .then(() => {
          this.$swal({
            title: "Success",
            text: "Customer added successfully!!",
            type: "success",
          });
        });
      this.$emit("created", {});
      this.$store.dispatch("partner/fetchPartnerCustomerList", {});
    },
  },
};
</script>

<style>
.vue-tel-input {
  border-radius: 0px !important;
  height: 39px !important;
  border: 1px solid #dee2e6 !important;
}
</style>
